import styled from 'styled-components';

export const StyledIngredientCard = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  padding: ${props => props.theme.spacing(4)};
  background: ${props => props.theme.colors.background.lightest};
  border-radius: 8px;
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.16);
  @media ${props => props.theme.laptop} {
    flex-basis: calc(33.33% - 8px);
  }
`;

export const IngredientImage = styled.figure`
  flex: 1;
  margin-right: ${props => props.theme.spacing(3)};
  max-width: 100px;
  width: 100%;
`;

export const IngredientCardBody = styled.div`
  flex: 1;
  text-align: left;
  ${props => props.theme.typography.subheading2};
  @media ${props => props.theme.laptop} {
    ${props => props.theme.typography.subheading2};
  }
`;

export const InfoContainer = styled.div`
  flex: 2;
`;

export const Headline = styled.h4`
  ${props => props.theme.typography.heading6};
  text-align: left;
  @media ${props => props.theme.laptop} {
    ${props => props.theme.typography.heading5};
  }
  padding-bottom: ${props => props.theme.spacing(2)};
`;

export const Image = styled.img`
  flex: 1;
  width: 100%;
`;
